import { IJwtUser } from '@renovationman/ts-utils';

export interface JwtPayload {
  user?: IJwtUser;
  sub?: string;
  iss?: string;
  exp?: number;
}

/**
 * Lit la charge utile d'un JWT **sans vérifier sa signature**.
 *
 * C'est légitime ici et seulement ici : le jeton vient d'être obtenu par le client lui-même, sur un
 * canal TLS, en échange d'un code qu'il a demandé — le profil « client OIDC » de la RFC 8725 dispense
 * explicitement de re-vérifier dans ce cas. Ce serait illégitime pour un jeton reçu d'ailleurs.
 *
 * ⚠️ `AuthService.parseJwt` fait la même chose pour le jeton rangé en `localStorage`. Les deux doivent
 * fusionner quand les applications basculeront (O2.7) ; ce lot est délibérément additif et ne touche
 * pas au contrat existant d'`AuthService`.
 */
export function decodeJwtPayload<T = JwtPayload>(token: string): T | null {
  const segment = token?.split('.')[1];
  if (!segment) {
    return null;
  }
  try {
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}
